import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

interface HeaderWrapperProps {
  login?: boolean;
}

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  padding: 12px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  position: static;
  width: 100%;
  height: 56px;
  z-index: 200;
  background-color: ${theme.colours.header};
  .noMarginTop {
    margin-top: 0;
  }
  .large-screen,
  .small-screen {
    width: 90px;
    height: 40px;
  }
  svg {
    cursor: pointer;
  }
  button {
    margin: 0 8px;
    cursor: pointer;
    background: ${theme.colours.header};
    padding: 7px;
    border: none;
    outline: none;
  }

  .container-select {
    top: 38px !important;
    left: 0 !important;
    padding: 8px 12px;
    z-index: 4;
  }
  @media (max-width: 768px) {
    padding: 12px 0px;

    display: ${(props) => (props.login ? 'none !important' : 'inline-block')};
    position: sticky;
    top: 0;
    z-index: 200;
    .default-photo {
      margin-left: 16px;
    }
  }
  @media (min-width: 768px) {
    button.menu {
      display: none;
    }
  }
`;

export const MemberPhoto = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  cursor: pointer;

  @media (max-width: 768px) {
    margin-left: 16px;
  }
`;
